<script setup lang="ts">
import type { ProductReviewFragment } from '#graphql-operations'

defineProps<{
  reviews: ProductReviewFragment[]
}>()

const productReviewStore = useProductReviewsStore()
const reviewDetailDialog = useTemplateRef('reviewDetailDialog')

function onOpenReview(value: ProductReviewFragment, assetIndex: number) {
  // Only open if the review has assets
  if (!value.assets || value.assets.length === 0)
    return

  reviewDetailDialog.value?.openReview(value.id, assetIndex)
}

async function handleUpvote(review: ProductReviewFragment) {
  if (productReviewStore.hasVoted(String(review.id))) {
    // await productReviewStore.voteOnReview(review.id, false)
  }
  else {
    await productReviewStore.voteOnReview(review, true)
    productReviewStore.markAsVoted(String(review.id))
  }
}
</script>

<template>
  <div>
    <div class="space-y-6">
      <ProductReviewListItem
        v-for="(item, index) in reviews"
        :key="index"
        :review="item"
        @open="onOpenReview"
        @upvote="handleUpvote"
      />
    </div>

    <ProductReviewDetailDialog ref="reviewDetailDialog" :reviews="reviews" />
  </div>
</template>
